(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationParameterDetailController', CommunicationParameterDetailController);

    CommunicationParameterDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function CommunicationParameterDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.communicationParameter = entity;
        vm.previousState          = previousState.name;
        // eslint-disable-next-line
        var unsubscribe = $rootScope.$on('eDocumentsApp:communicationParameterUpdate', function (event, result) {
            vm.communicationParameter = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
